import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-4 bg-white border border-[#d8d8e2] rounded-lg p-4 text-left"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-bold leading-6 text-[#16161d]" }, "Histórico", -1)
const _hoisted_3 = { class: "flex flex-col gap-2" }
const _hoisted_4 = { class: "flex flex-col items-center" }
const _hoisted_5 = {
  key: 0,
  class: "w-3 h-3 rounded-full bg-[#2f7f91] shrink-0"
}
const _hoisted_6 = {
  key: 1,
  class: "w-3 h-3 flex items-center justify-center shrink-0"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-2 h-2 rounded-full bg-[#16161d]" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "w-px flex-1 bg-[#d8d8e2] my-1"
}
const _hoisted_10 = { class: "flex flex-col gap-0.5 pb-2" }
const _hoisted_11 = { class: "text-sm leading-[18px] text-[#323232]" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "text-xs leading-[14px] text-[#808080]" }

import { computed } from 'vue'
import { FacialBiometryStatus } from '@/constants/facial-biometry.constants'
import type {
  FacialBiometryDoctorItem,
  FacialBiometryHistoryEntry
} from '@/types/facial-biometry.types'
import { formatDateInOffset, formatHourMinuteWithZoneInOffset } from '@/utils/date'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'


export default /*#__PURE__*/_defineComponent({
  __name: 'BiometryHistoryCard',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const props = __props;



const entries = computed<FacialBiometryHistoryEntry[]>(() => {
  const doctor = props.doctor
  if (!doctor) return []

  const result: FacialBiometryHistoryEntry[] = []

  if (doctor.reviewedAt && doctor.reviewedBy) {
    const statusAction =
      doctor.status === FacialBiometryStatus.VERIFIED
        ? 'Biometria facial aprovada'
        : 'Biometria facial reprovada'
    result.push({
      action: statusAction,
      date: formatDateInOffset(doctor.reviewedAt) ?? '',
      time: formatHourMinuteWithZoneInOffset(doctor.reviewedAt) ?? '',
      performedBy: doctor.reviewedBy.name
    })
  }

  if (doctor.createdAt) {
    result.push({
      action: 'Biometria facial enviada',
      date: formatDateInOffset(doctor.createdAt) ?? '',
      time: formatHourMinuteWithZoneInOffset(doctor.createdAt) ?? '',
      performedBy: doctor.doctor.name
    })
  }

  return result
})

return (_ctx: any,_cache: any) => {
  return (entries.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entries.value, (entry, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex gap-2"
            }, [
              _createElementVNode("div", _hoisted_4, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
                (index < entries.value.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(entry.date), 1),
                  _createTextVNode(" " + _toDisplayString(entry.action), 1)
                ]),
                _createElementVNode("p", _hoisted_13, _toDisplayString(entry.time) + ", por " + _toDisplayString(_unref(getFirstAndSecondName)(entry.performedBy)), 1)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})